class completeTheLook {
  constructor() {
    this.wrapper = document.querySelector(".complete-the-look__products");
    this.init();
  }
  init() {
    this.images = this.wrapper.querySelectorAll("img");
    this.setImageDimensions();
    // Add resize event listener to handle window resizing
    window.addEventListener("resize", () => this.setImageDimensions());
    // Add load event listeners to handle image loading
    this.images.forEach((img) => {
      img.addEventListener("load", () => this.setImageDimensions());
    });
  }
  setImageDimensions() {
    if (this.images.length < 2) return;

    const firstImage = this.images[0];
    const width = firstImage.offsetWidth;
    const height = firstImage.offsetHeight;

    // Apply dimensions to all other images
    for (let i = 1; i < this.images.length; i++) {
      this.images[i].style.width = `${width}px`;
      this.images[i].style.height = `${height}px`;
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new completeTheLook();
});
